/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue';

import 'es6-promise/auto'
import './bootstrap';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import VueCircle from 'vue2-circle-progress'
import Slick from 'slick-carousel';
import store from './store';
import VueChartkick from 'vue-chartkick';
import BootstrapVue from 'bootstrap-vue'
// const VueInputMask = require('vue-inputmask').default;
// import VueInputMask from 'vue-inputmask';

Vue.use(VueChartkick);
Vue.use(BootstrapVue);
// Vue.use(VueInputMask); // todo 


import accountEdit from './components/Account/Edit.vue';
import freeLookupForm from './components/FreeLookupForm.vue';
import freeLookupWithBundleForm from './components/FreeLookupWithBundleForm.vue';
import pageReviewsBody from './components/Page/ReviewsBody.vue';
import selectReport from './components/FreeCarCheck/SelectReport.vue';
import applePay from './components/FreeCarCheck/ApplePay.vue';
import buyReport from './components/FreeCarCheck/BuyReport.vue';
import stripePay from './components/FreeCarCheck/StripePay.vue';
import freePay from './components/FreeCarCheck/FreePay.vue';
import viewReport from './components/FreeCarCheck/ViewReport.vue';
import dashboardIndex from './components/App/Dashboard/Index.vue';
import receiptIndex from './components/App/Receipt/Index.vue';
import editSettings from './components/App/Settings/EditSettings.vue';
import showReport from './components/App/Report/ShowReport.vue';
import flash from './components/App/Flash.vue';
import mobileReceipt from './components/App/Receipts/MobileReceipt.vue';
import similarPostsCarousel from './components/Blog/SimilarPostsCarousel.vue';
import fiveStarWidget from './components/Page/FiveStarWidget.vue';
import scrollTo from './components/Page/ScrollTo.vue';
import blogRecentPosts from './components/Blog/RecentPosts.vue';
import blogAllCategories from './components/Blog/AllCategories.vue';
import authNav from './components/AuthNav.vue';
import lazyImage from './components/LazyImage.vue';
import buyGiftVoucher from './components/App/GiftVoucher/BuyGiftVoucher.vue';



Vue.component('account-edit', accountEdit);
Vue.component('free-lookup-form', freeLookupForm);
Vue.component('free-lookup-with-bundle-form', freeLookupWithBundleForm);
Vue.component('page-reviews-body', pageReviewsBody);
Vue.component('select-report', selectReport);
Vue.component('apple-pay', applePay);
Vue.component('buy-report', buyReport);
Vue.component('stripe-pay', stripePay);
Vue.component('free-pay', freePay);
Vue.component('view-report', viewReport);
Vue.component('dashboard-index', dashboardIndex);
Vue.component('receipt-index', receiptIndex);
Vue.component('edit-settings', editSettings);
Vue.component('show-report', showReport);
Vue.component('flash', flash);
Vue.component('mobile-receipt', mobileReceipt);
Vue.component('similar-posts-carousel', similarPostsCarousel);
Vue.component('five-star-widget', fiveStarWidget);
Vue.component('scroll-to', scrollTo);
Vue.component('blog-recent-posts', blogRecentPosts);
Vue.component('blog-all-categories', blogAllCategories);
Vue.component('auth-nav', authNav);
Vue.component('lazy-image', lazyImage);
Vue.component('buy-gift-voucher', buyGiftVoucher);


const app = new Vue({
    el: '#app',
    store,
    data: {
        menu: false,
        dashMenu: false,
        search: {
            blog_search: null,
            per_page: null,
        },
        //disable buttons on submit
        disableOnSubmit: false,
        bundle: false,
        //stripe: {},
    },
    props: {
        perPage: {
            type: Number,
            default: 12
        },
        blogSearch: {
            type: String,
            default: ''
        },
    },

    mounted() {
        this.search.per_page = this.$el.attributes['per-page'].value;
        this.search.blog_search = this.$el.attributes['blog-search'].value;
        //this.stripe = Stripe("pk_test_gyPu63bOoNL3ZFv3oANh80h100u2JZtaIV");
    },

    watch: {
    },

    methods: {
        updateSearch(key, value) {
            this.search[key] = value;
            Vue.nextTick(function () {
                document.getElementById('blog-search-form').submit();
            })
        },

        /**
         * General helper method for any forms in the site
         *
         * @param  {obj} event
         *
         * @return {void}
         */
        validateAndSubmit(scope) {
            this.disableOnSubmit = true;
            let _self = this;

            setTimeout(function () {
                _self.disableOnSubmit = false;
            }, 500);

            this.$validator.validateAll(scope).then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    let form = document.getElementById(scope);
                    form.submit();
                }
            });
        },

        /**
         * Append the necessary bootstrap validation class to an element if
         * invalid
         *
         * @param  {Boolean} hasErrors
         *
         * @return {string}
         */
        validationClass(hasErrors) {
            return hasErrors ? 'is-invalid' : null;
        },

        /**
         * General helper method for any forms in the site
         *
         * @param  {obj} event
         *
         * @return {void}
         */
        toggleExpander(event) {
            let _self = this;

            let expanderParent = event.target.parentNode.parentNode.parentNode;

            // If they're reclicking an already open one, just toggle it closed
            if (expanderParent.classList.contains('open')) {
                expanderParent.classList.toggle('open');
            } else {
                // Get all open expanders
                let expanders = document.getElementsByClassName('expander open')

                // Make sure to close all other expanders
                Array.prototype.forEach.call(expanders, function (expander, index) {
                    expander.classList.remove('open');
                });

                // and then open the current one
                expanderParent.classList.add('open');
            }
        },

        /**
         * Get the correct interstitials depending on car country (IE/UK) and type of report
         *
         * @param  {string} vrm
         * @param  {string} type
         *
         * @return {Array}
         */
        getInterstitials(vrm, type) {
            var irishCar = false;

            if (vrm.match("^(\\d{2,3}-?(KK|kk|ww|WW|c|C|ce|CE|cn|CN|cw|CW|d|D|dl|DL|g|G|ke|KE|ky|KY|l|L|ld|LD|lh|LH|lk|LK|lm|LM|ls|LS|mh|MH|mn|MN|mo|MO|oy|OY|so|SO|rn|RN|tn|TN|ts|TS|w|W|wd|WD|wh|WH|wx|WX)-?\\d{1,5})$")) {
                irishCar = true;
            }

            if (irishCar) {
                switch (type) {
                    case 'history':
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking NVDF and VRO data from Government databases...',
                            },
                            {
                                icon: 'icon-detailed-mileage-check',
                                text: 'Checking over 300m readings in Mileage Database...',
                            },
                            {
                                icon: 'icon-write-off-scrapped',
                                text: 'Checking Motorcheck Insurance Write-Off Database...',
                            },
                            {
                                icon: 'icon-stolen',
                                text: 'Checking Motorcheck Stolen Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                    case 'finance':
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking NVDF and VRO data from Government databases...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Finance Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                    case 'full':
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking NVDF and VRO data from Government databases...',
                            },
                            {
                                icon: 'icon-detailed-mileage-check',
                                text: 'Checking over 300m readings in Mileage Database...',
                            },
                            {
                                icon: 'icon-write-off-scrapped',
                                text: 'Checking Motorcheck Insurance Write-Off Database...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Finance Database...',
                            },
                            {
                                icon: 'icon-stolen',
                                text: 'Checking Motorcheck Stolen Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                    default:
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking vehicle data from our Government databasess...',
                            },
                            {
                                icon: 'icon-detailed-mileage-check',
                                text: 'Checking over 350m readings in our Mileage databases...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Insurance Write-Off databases...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Finance databases...',
                            },
                            {
                                icon: 'icon-stolen',
                                text: 'Checking Stolen Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                }
            } else {
                switch (type) {
                    case 'history':
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking DVLA and MOT data from Government databases...',
                            },
                            {
                                icon: 'icon-detailed-mileage-check',
                                text: 'Checking over 300m readings in Mileage Database...',
                            },
                            {
                                icon: 'icon-write-off-scrapped',
                                text: 'Checking MIAFTR Insurance Write-Off Database...',
                            },
                            {
                                icon: 'icon-stolen',
                                text: 'Checking Police Stolen Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                    case 'finance':
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking DVLA and MOT data from Government databases...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Finance Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                    case 'full':
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking DVLA and MOT data from Government databases...',
                            },
                            {
                                icon: 'icon-detailed-mileage-check',
                                text: 'Checking over 300m readings in Mileage Database...',
                            },
                            {
                                icon: 'icon-write-off-scrapped',
                                text: 'Checking MIAFTR Insurance Write-Off Database...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Finance Database...',
                            },
                            {
                                icon: 'icon-stolen',
                                text: 'Checking Police Stolen Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                    default:
                        return [
                            {
                                icon: 'icon-mot-tax-check',
                                text: 'Checking vehicle data from our Government databasess...',
                            },
                            {
                                icon: 'icon-detailed-mileage-check',
                                text: 'Checking over 350m readings in our Mileage databases...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Insurance Write-Off databases...',
                            },
                            {
                                icon: 'icon-finance-check',
                                text: 'Checking Finance databases...',
                            },
                            {
                                icon: 'icon-stolen',
                                text: 'Checking Stolen Database...',
                            },
                            {
                                icon: 'icon-tick',
                                text: 'Your report is now ready!',
                            },
                        ];
                }
            }
        },

    },
    components: {
        VueCircle,
    }
});


/*
 *
 * HOME PAGE - FLIPPING VRM PLATES
 *
 */

/**
 * Set an interval based on the number of regplates to flip each one in sequence
 * and then start again
 *
 * @param      {object}  vrmPlates
 *
 * @return     {void}
 */
function loopVrmPlateFlipping(vrmPlates) {
    setInterval(function () {
        flipVrmPlates(vrmPlates);
    }, vrmPlates.length * 1000);
};

/**
 * Flip each reg plate in order based on their data-offset property
 *
 * @param      {object}  vrmPlates
 *
 * @return     {void}
 */
function flipVrmPlates(vrmPlates) {
    Array.prototype.forEach.call(vrmPlates, function (vrmPlate, index) {
        let offset = vrmPlate.dataset.offset;

        setTimeout(function () {
            vrmPlate.classList.toggle('flipped');
        }, offset * 1000);
    });
};

window.addEventListener('load', function () {
    // Find all flippable reg plate elements
    let vrmPlates = document.getElementsByClassName('vrm-display-flip');

    // Flip the reg plates on load if they exist
    if (vrmPlates && vrmPlates.length) {
        flipVrmPlates(vrmPlates);
        loopVrmPlateFlipping(vrmPlates);
    }
});


$(function () {
    $('[data-toggle="popover"]').popover()
    $('[data-toggle="tooltip"]').tooltip()
});

$('body').on('click', function (e) {
    $('[data-toggle=tooltip]').each(function () {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.tooltip-inner').has(e.target).length === 0) {
            $(this).tooltip('hide');
        }
    });
});

//purchase funnel variants carousel

$('#carousel').on('slide.bs.carousel	', '', function () {
    $('.carousel-control-prev').hide();
    $('.carousel-control-next').hide();
});
$('#carousel').on('slid.bs.carousel	', '', function () {
    $('.carousel-control-prev').show();
    $('.carousel-control-next').show();
});
